import { AppDispatch } from "../../../app/store";
import storage from "../../../utils/store/storage";
import { LOGIN_TOKEN } from "../../../utils/store/storeVariables";
import { setLoginToken as setLoginTokenAction } from "../sessionSlice";

export function setLoginToken(dispatch: AppDispatch, loginToken: string, rememberMe: boolean) {
  storage.saveItem(LOGIN_TOKEN, rememberMe, loginToken);
  dispatch(setLoginTokenAction(loginToken));
}
